import { render, staticRenderFns } from "./WsExamGroupsParticipantsDetails.vue?vue&type=template&id=c2a11a74"
import script from "./WsExamGroupsParticipantsDetails.vue?vue&type=script&lang=js"
export * from "./WsExamGroupsParticipantsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports